import {
    Empty, Image, Input, Radio, Tooltip
} from "antd";
import React, { useState } from "react";
import globalmedical from "../../../images/country/globalmedical.png";
import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import useSearchInCountry from "./useSearchInCountry";

const countryIconUrl = "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/";

const CountryList = function ({
    countryList = [],
    setselectedCountry = () => { },
    selectedCountry,
    marketPackage,
    className,
    placeholder = "Search Country",
    label = "Select Country",
    emptyElementRender,
    forceAvailableList,
    getIcon,
    getCountryStatus,
    countryStatusRender,
    countryItemRender,
    hideLoadingCountry
}) {
    const [searchedText, setsearchedText] = useState("");

    const isCountryLoaded = getCountryStatus || (() => true);
    const countryStatus = countryStatusRender || ((status) => {
        if (!status) {
            return (
                <Tooltip title="Country is not loaded.">
                    <InfoCircleOutlined style={{
                        cursor: "pointer",
                        color: "#800000"
                    }}
                    />
                </Tooltip>
            );
        }
        if (status === "proccessing") {
            return (
                <LoadingOutlined
                    title="Checking country status... Please wait."
                    style={{
                        color: "#1d4ed8"
                    }}
                />
            );
        }
        return null;
    });

    const { searched, searching } = useSearchInCountry(searchedText, countryList);

    const getCountryContent = () => {
        const toDisplayData = (searchedText ? searched : countryList).filter((cty) => {
            const { loaded } = cty;
            // if (forceAvailableList && !forceAvailableList.includes(attribute.enterpriseCode)) return null;
            const isLoaded = loaded || isCountryLoaded(cty);
            if (hideLoadingCountry && isLoaded === "proccessing") return null;
            return cty
        });
        if (!searching && toDisplayData.length) {
            return (
                <Radio.Group
                    className="countryList_container_list_group"
                    onChange={(e) => {
                        setselectedCountry(toDisplayData.find((c) => c.id === e.target.value), e);
                    }}
                    value={selectedCountry?.id || ""}
                >
                    {toDisplayData.map((cty) => {
                        if (countryItemRender) { return countryItemRender(cty); }
                        const { attribute, loaded } = cty;
                        let countryIcon = null;
                        let style = {};

                        if (!getIcon) {
                            const enterpriseCode = cty.enterpriseCode || attribute.enterpriseCode
                            if (enterpriseCode === "medical") {
                                countryIcon = globalmedical;
                                style = {
                                    objectFit: "contain",
                                    width: "26px",
                                    marginLeft: "2px"
                                };
                            } else {
                                let country2Code = cty["2letterCode"] || (attribute?.codes || []).find((code) => code.length === 2);
                                if (country2Code === "uk") country2Code = "gb"
                                else if (country2Code === "ks") country2Code = "sa"
                                countryIcon = `${countryIconUrl + country2Code.toLocaleUpperCase()}.svg`;
                            }
                        }
                        const isLoaded = loaded || isCountryLoaded(cty);
                        return (
                            <Radio
                                key={cty.id}
                                value={cty.id}
                                disabled={isLoaded !== true}
                            >
                                <div className="countryList_item">
                                    {getIcon
                                        ? getIcon(cty)
                                        : <Image className="countryList_item_icon" preview={false} src={countryIcon} style={style} />}
                                    <div className="countryList_item_name">{cty.name}</div>
                                    {countryStatus(isLoaded)}
                                </div>
                            </Radio>
                        );
                    })}
                </Radio.Group>
            );
        }
        let description = "No available country in selected Market Package.";
        if (!marketPackage) {
            description = "Please Select Market Package.";
        }
        if (searchedText && !toDisplayData.length) {
            description = "No Result Found.";
        }
        if (!toDisplayData.length) {
            description = "No Available Country.";
        }
        if (searching) {
            description = "Searching. Please wait...";
        }

        return (emptyElementRender ? emptyElementRender(description) : (
            <Empty
                className="countryList_container_empty"
                description={<span style={{ whiteSpace: "pre-wrap" }}>{description}</span>}
            />
        )
        );
    };
    return (
        <div className={`countryList_container ${className}`}>
            {countryList.length
                ? (
                    <>
                        <div className="countryList_container_label">{label}</div>
                        <Input.Search
                            placeholder={placeholder}
                            style={{ width: "100%" }}
                            value={searchedText}
                            onChange={(e) => {
                                setsearchedText(e.target.value);
                            }}
                            onSearch={(e) => {
                                setsearchedText(e);
                            }}
                        />
                    </>
                ) : null}
            <div className="countryList_container_list">
                {getCountryContent()}
            </div>
        </div>
    );
};

export default CountryList;
